
import XButton from 'vux/src/components/x-button/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'

export default {
name: "discountsItem",
props: {
discountsInfo: {
type: Array,
default: () => [],
},
discountsTitle: {
type: String,
default: "",
},
},
components: { XButton, XImg, Divider, InlineLoading },
methods: {
handleGoDetail({ id, articleName, applyType, bonusType, configId }) {


this.$router.push({
path: "/discounts/discountsDetail",
query: { id, articleName, applyType, bonusType, configId },
});

},
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/discounts/components/dis-content.vue